import { IStoragesState } from "./reducer";

const initialState: IStoragesState = {
  storages: [],
  isFetchingStorages: false,
  hasFetchedStorages: false,

  availableSkus: [],
  isFetchingSkus: false,
  currentSourceStorageId: null,
};

export default initialState;
